import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  :root {
    --ax-white: #fff;
    --ax-beige: #efede4;
    --ax-gold: #ce9200;
    --ax-gold-dark:#8c6403;
    --ax-grey: #c1beac;
    --ax-black: #1d1d1b;
    --ax-purple: #5d3995;
    --ax-pink: #ee2856;
    --ax-green: #009245;
    --ax-light-green: #dff0e7;
    --ax-blue: #008BEA;
    --ax-red: #D82E4A;
    --ax-bright-pink: #FF8DFF;
    --ax-bright-green: #92ED5D;
    --ax-orange-yellow: #FFC904;
    --ax-bright-blue: #0026FF;
    --gb-blue: #005CD3;
    --gb-pink: #CA62DF;
    --gb-white: #FFFFF0;
    --gb-grey: #353535;
    /* Set at runtime by Header/Menu; default 0 so the closed menu's clip-path
       calc() is valid on the server / at first paint (before hydration). */
    --scrollbar-width: 0px;
  }

  html {
    box-sizing: border-box;
  }

  html,
  body {
    width: 100%;
    height: 100%;
  }

  .ot-pc-footer-logo {
    display: none !important;
  }

  *, *:before, *:after {
    box-sizing: inherit;

  }

  body {
    color: #000;
    background: #090a12;
    overflow-x: hidden;
  }

  body,
  h1,
  h2,
  h3,
  h4,
  p,
  ul,
  li {
    margin: 0;
    padding: 0;
    font-family: "proxima-nova";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-display:swap;

  }

  button {
    border: none;
    position: relative;
    ${
      '' /* &:focus {
      outline:  2px solid var(--ax-blue);
      animation: focusPulse 1.5s infinite;
      z-index: 100;
    } */
    }
  }

  ${
    '' /* a, li {
    position: relative;
    &:focus {
      outline: 2px solid var(--ax-blue);
      animation: focusPulse 1.5s infinite;
      z-index: 100;
    }
  }

  @keyframes focusPulse {
    0% {
      outline: 2px solid var(--ax-blue);
    }
    50% {
      outline: 4px solid rgba(48, 63, 72, 0.6);
    }
    100% {
      outline: 2px solid var(--ax-blue);
    }   
  } */
  }

  #smooth-content {
    position: relative;
  }
`;
